export const EstadoUsuario = {
  Activo: 0,
  Inactivo: 1,
  Eliminado: 2,
  Bloqueado: 6,
};

export const TipoPerfil = {
  Carpeta: 1,
  Link: 2,
};

export const TablaSeleccion = {
  TipoDocument: 2,
  SiNo: 16,
  Naturaleza: 75,
  Predefinida: 77,
  LLaves: 78,
  TipoUser: 79,
  EstadoUser: 80,
  EstadoActivoInactivo: 81,
  TipoPerfil: 82,
  TipoOperacionCalculado: 83,
  SimboloOperacion: 84,
  TipoPlantilla: 85,
  TipoRespuesta: 86,
  FormaPago: 87,
  TipoCuenta: 88,
  TipoTextoNotificacion: 89,
  TipoEnvioNotificacion: 90,
  CalculoDias: 91,
  DestinatarioInt: 92,
  DestinatarioExt: 93,
  TipoDisparador: 94,
  TipoContenido: 95,
  IndicativoCarpeta: 96,
  TipoInformacion: 97,
  Formato: 98,
};
